import { graphql } from "../__generated__/gql";

export const GET_PRODUCT_YEAR_QUERY = graphql(`
  query GetProductYearData(
    $productClass: ProductClass!
    $productLevel: Int!
    $yearMin: Int
    $yearMax: Int
    $servicesClass: ServicesClass!
  ) {
    productYear(
      productClass: $productClass
      productLevel: $productLevel
      yearMin: $yearMin
      yearMax: $yearMax
      servicesClass: $servicesClass
    ) {
      productId
      year
      pci
      exportValue
      importValue
    }
  }
`);

export default GET_PRODUCT_YEAR_QUERY;
